<template>
  <div v-if="visible" class="member-web-notice-modal" role="alertdialog" aria-modal="true" tabindex="-1">
    <div class="member-web-notice-modal__overlay" @click="closeModal" />
    <div class="member-web-notice-modal__dialog" @keydown.esc="closeModal">
      <header class="member-web-notice-modal__header">
        <h2 class="member-web-notice-modal__title">Notice</h2>
        <button class="member-web-notice-modal__close" @click="closeModal" aria-label="Close notice">&times;</button>
      </header>
      <div class="member-web-notice-modal__content">
        <p class="member-web-notice-modal__message">
          We are aware that some members are experiencing difficulties accessing member web. We are currently investigating this issue and aim to resolve this as quickly as possible. If you are experiencing any issues that require a quicker response please email
          <a href="mailto:enquiries@lcp.uk.com" class="member-web-notice-modal__link">enquiries@lcp.uk.com</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'MemberWebNoticeModal',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            visible: this.value,
        };
    },
    watch: {
        value (val) {
            this.visible = val;
        },
        visible (val) {
            this.$emit('input', val);
        },
    },
    methods: {
        closeModal () {
            this.visible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.member-web-notice-modal {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  animation: fadeInBg 0.2s;

  &__overlay {
    display: none; // overlay handled by parent
  }

  &__dialog {
    position: relative;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.18), 0 1.5px 6px rgba(0,0,0,0.08);
    max-width: 520px;
    width: 92vw;
    min-width: 0;
    padding: 0;
    outline: none;
    display: flex;
    flex-direction: column;
    animation: popIn 0.22s cubic-bezier(.4,1.6,.6,1);
    white-space: normal;
    overflow-x: visible;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.2rem 1.5rem 0.7rem 1.5rem;
    border-bottom: 1px solid #f0f0f0;
    background: #f8fafd;
    border-radius: 16px 16px 0 0;
  }

  &__title {
    font-size: 1.25rem;
    font-weight: 700;
    margin: 0;
    color: #1a2340;
    letter-spacing: 0.01em;
  }

  &__close {
    background: none;
    border: none;
    font-size: 2rem;
    line-height: 1;
    color: #b0b0b0;
    cursor: pointer;
    padding: 0 0.2em;
    margin-left: 1rem;
    border-radius: 50%;
    transition: background 0.2s, color 0.2s;
    &:hover,
    &:focus {
      color: #1a2340;
      background: #e6eaf3;
      outline: none;
    }
  }

  &__content {
    padding: 2rem 1.5rem 2.2rem 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    background: #fff;
    border-radius: 0 0 16px 16px;
  }

  &__message {
    font-size: 1.08rem;
    color: #2a2a2a;
    text-align: left;
    margin-bottom: 0.5rem;
    line-height: 1.6;
    letter-spacing: 0.01em;
    white-space: normal;
    overflow-x: visible;
  }

  &__link {
    color: #0056b3;
    text-decoration: underline;
    white-space: nowrap;
    transition: color 0.2s;
    &:hover,
    &:focus {
      color: #003366;
      outline: none;
    }
  }

  @media (max-width: 600px) {
    &__dialog {
      max-width: 98vw;
      padding: 0;
    }
    &__header, &__content {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
}

@keyframes fadeInBg {
  from { background: rgba(0,0,0,0); }
  to { background: rgba(0,0,0,0.35); }
}

@keyframes popIn {
  from { transform: scale(0.95) translateY(20px); opacity: 0; }
  to { transform: scale(1) translateY(0); opacity: 1; }
}
</style>
